<mat-progress-bar *ngIf="duplicatePairsLoading" mode="indeterminate" class="dup-progress"></mat-progress-bar>

<ng-container *ngIf="filteredRows.length; else noItems">
    <mat-list>
        <div class="list-header" *ngIf="!filterValue">Duplicate Alerts</div>
        <app-duplicate-alert-list-item *ngFor="let row of filteredRows | slice:0:shown" [row]="row"></app-duplicate-alert-list-item>
        <div *ngIf="shown < filteredRows.length" (appRenderMore)="shown = shown + renderBatch"></div>
    </mat-list>
</ng-container>
<div class="mobile-spacer"></div>

<ng-template #noItems>
    <div *ngIf="duplicatePairsLoading" class="dup-loading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
    <p *ngIf="!duplicatePairsLoading" class="no-records-message">No duplicate alerts found.</p>
</ng-template>
